

































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'PurchaseOrderResourceListItem'

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      offerStats: -> @ctxStats(@item).offer || {}


export default VueOptions.vue settings
